import axios from "axios";
import PATH from "./URL";

async function GetSlides(func){
    const response = await axios.get(`${PATH}/api/v1/get_slides`)
    return func(response.data)
}

export default GetSlides